// Dernière configuration publique connue (/config/public : traductions, blocs, réglages…), par langue.
// Sert d'amorce au démarrage (hors ligne ou réseau lent) et d'écran de secours tant que le serveur ne répond pas.
const KEY = "yalola.config.";

export const readCachedConfig = (lang) => {
  try {
    const raw = localStorage.getItem(KEY + lang);
    if (!raw) return null;
    const data = JSON.parse(raw);
    return data && data.translations && Array.isArray(data.layout_blocks) ? data : null;
  } catch { return null; }
};

export const writeCachedConfig = (lang, data, etag) => {
  try {
    localStorage.setItem(KEY + lang, JSON.stringify(data));
    if (etag) localStorage.setItem(KEY + lang + ".etag", etag); else localStorage.removeItem(KEY + lang + ".etag");
  } catch { /* quota / privé : sans cache */ }
};

// ETag de la dernière config reçue → If-None-Match → 304 (rien à télécharger) si rien n'a changé côté serveur.
export const readCachedConfigEtag = (lang) => {
  try { return readCachedConfig(lang) ? localStorage.getItem(KEY + lang + ".etag") : null; } catch { return null; }
};

// Relances après un échec de chargement : 2 s, 5 s, 10 s, 20 s puis toutes les 30 s.
export const retryDelay = (attempt) => [2000, 5000, 10000, 20000][attempt] ?? 30000;
